export const isLoyaltyTrainerEnabled = (
  networkTags?: Array<{
    tag_id?: number;
    id?: number;
    name?: string;
    code?: string;
  }>
) => {
  if (
    process.env.NODE_ENV !== 'production' &&
    process.env.REACT_APP_LOYALTY_TRAINER_PREVIEW === 'true'
  )
    return true;
  const devTagId =
    window.location.hostname === 'dev-apteka.daribar.kz' ? 1065 : 0;
  const tagId =
    devTagId || Number(process.env.REACT_APP_LOYALTY_TRAINER_TAG_ID || 0);
  return (
    tagId > 0 &&
    Boolean(networkTags?.some((tag) => Number(tag.tag_id ?? tag.id) === tagId))
  );
};
